export default __webpack_public_path__ + "static/media/cmc_p.5fe44a42.png";